import React from 'react';
import { BoxStyle as S } from './Box.style';
import { borders, colourPalette, padding, borderRadius, shadow } from 'styles/styles';

type BoxProps = {
  padding?: keyof typeof padding | (keyof typeof padding)[];
  borderWidth?: keyof typeof borders | (keyof typeof borders)[];
  borderColor?: keyof typeof colourPalette;
  backgroundColor?: keyof typeof colourPalette;
  backgroundColorAlpha?: number;
  radius?: keyof typeof borderRadius;
  shadow?: keyof typeof shadow;
  stretch?: boolean;
  fit?: 'content' | 'space';
  noAutoMinSize?:
    | 'width'
    | 'height'
    | 'both' /** @see https://www.bigbinary.com/blog/understanding-the-automatic-minimum-size-of-flex-items */;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  role?: React.AriaRole;
  maxWidth?: number;
  testId?: string;
  children?: React.ReactNode;
  className?: string;
};

export const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({ children, className, testId, onClick, role, ...props }, ref) => {
    return (
      <S.Box
        $props={props}
        $isClickable={!!onClick}
        className={className}
        data-testid={testId}
        onClick={onClick}
        role={role}
        ref={ref}
      >
        {children}
      </S.Box>
    );
  }
);
